import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { useConfig } from '@context/ConfigurationContext'
import * as styles from './styles'

const P21_LOGO = 'https://ucarecdn.com/d8062edf-b21b-438a-acd2-0bcdcb7e93c1/-/preview/273x49/'

const ExternalClinicFooter = () => {
  const { t } = useTranslation()
  const { clinicLogoUrl } = useConfig()

  return (
    <Box component="footer" sx={styles.footerContainer}>
      <Box sx={styles.leftCornerContent}>
        {clinicLogoUrl && <Box component="img" sx={styles.clinicLogo} src={clinicLogoUrl} alt="clinic_logo" />}
      </Box>
      <Box sx={styles.rightCornerContent}>
        <Typography sx={styles.p21LogoText}>{t('availy_footer_powered_by_label')}</Typography>
        <Box component="img" sx={styles.p21Logo} src={P21_LOGO} alt="p21_logo" />
      </Box>
    </Box>
  )
}

export default ExternalClinicFooter
